import React, { useState } from "react";
import { Row, Col, Card, Menu, Dropdown, Button } from "antd";
import { IoIosAddCircleOutline } from "react-icons/io";
import { BsThreeDotsVertical, BiCheckDouble } from "react-icons/all";
import Chip from "../../assets/images/chip.png";
import straightVisaCard from "../../assets/images/straight_cards_32.png";
import "./index.css";
import info from "../../components/info";
import { useDispatch } from "react-redux";
import { UserAction } from "../../store/actions";
import CustomModal from "../modals/customModal";
import Delete_order from "../../assets/images/delete_order.png";

export default function CreditCard({
  inputText,
  cardIcon,
  cardText,
  cardStyle,
  data,
  fromOrder,
  tickIcon,
  dotsIcon,
  paidText,
  shipVisaStyling,
  isOrderDetailCard,
}) {
  const [isOpenModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  const menu = (
    <Menu style={{ width: 0, padding: 0 }} className="menu-fit">
      {!data?.default_source && (
        <Menu.Item
          key="0"
          onClick={() => dispatch(UserAction.setCardDefaultReq(data.id))}
          style={{ marginLeft: "-5px" }}
        >
          <span className="st-primary">Set as default</span>
        </Menu.Item>
      )}

      <Menu.Item
        key="0"
        onClick={
          data?.default_source
            ? () => {
              info(
                "error",
                "Cannot delete default card! Make any other card your default and then delete this card"
              );
            }
            : () => setOpenModal(true)
        }
        style={{ marginLeft: "-5px" }}
      >
        <span className="st-primary">Delete</span>
      </Menu.Item>
    </Menu>
  );
  console.log("cardsss==>", data)
  return (
    <Row justify={fromOrder ? "space-between" : "center"} gutter={[10, 0]}>
      <Col xs={24} sm={24} md={24} lg={24} xl={23} className="credit-card">
        <Card className="ant-card-body" style={cardStyle}>
          <Row justify="start">
            <Col>
              {tickIcon && (
                <BiCheckDouble
                  color="lightblue"
                  size={25}
                  style={{
                    visibility: !data?.default_source ? "hidden" : "visible",
                  }}
                />
              )}
            </Col>
          </Row>
          <Row align="middle">
            {paidText &&
              <Col style={{ margin: "8px" }}
                xs={isOrderDetailCard && 11}
                sm={isOrderDetailCard && 11}
                md={isOrderDetailCard && 10}
                lg={isOrderDetailCard && 9}
                xl={isOrderDetailCard && 12}
                className="text-left"
              >Paid Via
              </Col>}

            <Col
              xs={isOrderDetailCard ? 5 : 5}
              md={isOrderDetailCard ? 4 : 6}
              lg={isOrderDetailCard ? 4 : 6}
              xl={isOrderDetailCard ? 4 : 5}
              style={{
                margin: shipVisaStyling && "8px -10px 0px 10px",
                height: "28px",
                backgroundImage: !shipVisaStyling && `url(${Chip})`,
                width: "28px",
                maxHeight: "28px",
                backgroundRepeat: "no-repeat",
                justifyContent: "end",

              }}
            >
              {shipVisaStyling && <img src={Chip} />}
            </Col>
            <Col
              xs={6}
              sm={6}
              md={8}
              lg={8}
              xl={isOrderDetailCard ? 5 : 14}
              style={{
                margin: shipVisaStyling && "8px -7px 0px 10px",
                height: "30px",
                backgroundImage: `url(${straightVisaCard}) `,
                width: "51px",
                display: "inline-block",
                position: "relative",
                backgroundPosition:
                  data?.source?.brand === "MasterCard"
                    ? "0px -158px"
                    : data?.source?.brand === "American Express"
                      ? "0 -240px"
                      : data?.source?.brand === "Discover"
                        ? "0 -400px"
                        : data?.source?.brand === "Diners Club"
                          ? "0 -480px"
                          : data?.source?.brand === "JCB"
                            ? "0 -320px"
                            : data?.source?.brand === "UnionPay"
                              ? "0 0px"
                              : data?.source?.object === "card"
                                ? "-4px -78px"
                                : "-2px 0.5px",
                width: "51px",
                backgroundRepeat: 'no-repeat'
              }}
            ></Col>
            <Col xs={8} sm={4} md={isOrderDetailCard ? 24 : 10} lg={10} xl={4}>
              {dotsIcon && (
                <Dropdown
                  overlay={menu}
                  trigger={["click"]}
                  style={{ width: "40%" }}
                >
                  <BsThreeDotsVertical className="pointer-cursor" />
                </Dropdown>
              )}
            </Col>
          </Row>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <h5
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "18px",
                  margin: "16px 0",
                }}
              >
                {`**** **** **** ${data?.source?.last4 || 4242}`}
              </h5>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col
              xl={12} lg={12} md={12} sm={2} xs={2} style={{ marginTop: "-10px", padding: '2px' }} className="text-left">
              <span className="plant-card-countryName">{data?.source?.country || "US"}</span>
              <span className="plant-card-country">COUNTRY</span>
            </Col>
            <Col
              xs={10}
              sm={8}
              md={12}
              lg={12}
              xl={6}
              style={{ marginTop: "-10px", padding: '2px', textAlign: 'left' }}
            >
              <span className={isOrderDetailCard ? "plant-card-expiryDate text-right" : "plant-card-expiryDate text-left"}>{`${data?.source?.exp_month}/${data?.source?.exp_year}`}</span>
              <span style={{ marginRight: isOrderDetailCard && '18px' }} className={isOrderDetailCard ? "plant-card-expiry text-right" : "plant-card-expiry text-left"} >EXP</span>
            </Col>
          </Row>
        </Card >
      </Col >
      <CustomModal
        visible={isOpenModal}
        onCancelModal={() => setOpenModal(false)}
        footer={[
          <Row justify="center" style={{ margin: "20px" }}>
            <Col
              className="d-flex justify-content-center"
              style={{ width: "100%" }}
            >
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() =>
                  dispatch(
                    UserAction.deleteCardReq(data.id, () => setOpenModal(false))
                  )
                }
              >
                YES
              </Button>
              <Button
                style={{
                  backgroundColor: "#26a69a ",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() => setOpenModal(false)}
              >
                NO
              </Button>
            </Col>
          </Row>,
        ]}
      >
        <Row justify="center">
          <Col className="d-flex justify-content-center" span={24}>
            <img src={Delete_order} />
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            <span>{"Are you sure you want to delete this card?"}</span>
          </Col>
        </Row>
      </CustomModal>
    </Row >
  );
}
